import React from 'react';

import {
  promoBannerCarouselPayloadDownloadFilename,
  serializePromoBannerCarouselPayload,
  serializePromoBannerCarouselPreviewPayload,
} from '~/utils/luxPlusPayloadBuilder/promoBannerCarousel/buildPayload';
import { createDefaultPromoBannerCarouselState } from '~/utils/luxPlusPayloadBuilder/promoBannerCarousel/defaults';
import { hasPromoBannerCarouselProgress } from '~/utils/luxPlusPayloadBuilder/promoBannerCarousel/hasProgress';
import { parsePromoBannerCarouselPayload } from '~/utils/luxPlusPayloadBuilder/promoBannerCarousel/parsePayload';
import type { LuxPlusPromoBannerCarouselState } from '~/utils/luxPlusPayloadBuilder/promoBannerCarousel/types';
import { validatePromoBannerCarouselPayload } from '~/utils/luxPlusPayloadBuilder/promoBannerCarousel/validatePayload';

import PayloadBuilderJsonPreview from '../../JsonPreview';
import StandalonePayloadActions from '../../StandalonePayloadActions';
import StandalonePayloadBuilderPage from '../../StandalonePayloadBuilderPage';

import PromoBannerCarouselPayloadBuilderForm from './PromoBannerCarouselPayloadBuilderForm';

interface PromoBannerCarouselPayloadBuilderPageProps {
  onProgressChange?: (hasProgress: boolean) => void;
}

export default function PromoBannerCarouselPayloadBuilderPage({
  onProgressChange,
}: PromoBannerCarouselPayloadBuilderPageProps) {
  return (
    <StandalonePayloadBuilderPage<LuxPlusPromoBannerCarouselState>
      onProgressChange={onProgressChange}
      createDefaultState={createDefaultPromoBannerCarouselState}
      hasProgress={hasPromoBannerCarouselProgress}
      parsePayload={parsePromoBannerCarouselPayload}
      validate={validatePromoBannerCarouselPayload}
      renderActions={(state, isValid, fullWidth) => (
        <StandalonePayloadActions
          state={state}
          isValid={isValid}
          fullWidth={fullWidth}
          serialize={serializePromoBannerCarouselPayload}
          getFilename={promoBannerCarouselPayloadDownloadFilename}
          payloadName="LuxPlus+ promo banners"
        />
      )}
      renderForm={(props) => <PromoBannerCarouselPayloadBuilderForm {...props} />}
      renderPreview={(state, borderSoft, maxHeight) => (
        <PayloadBuilderJsonPreview
          state={state}
          serialize={serializePromoBannerCarouselPreviewPayload}
          borderSoft={borderSoft}
          maxHeight={maxHeight}
        />
      )}
    />
  );
}
